export const DEVICE_SIZES = {
  MOBILE: 375,
  TABLET: 768,
  DESKTOP: 1280
};

export const DEVICES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
  CUSTOM: 'custom'
}; 